export default __webpack_public_path__ + "static/erone@2x-9acd2af195a8c1e5e1a96ce33bcc03bf.png";